import ReactDOM from 'react-dom';
import { Toaster } from 'react-hot-toast';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import store from './redux-stores/index';
import interceptor from './utils/Axios.interceptor';
import { toastrSettings } from './utils/Toastr';

// Axios Interceptor
interceptor(store);

const app = (
    <ReduxProvider store={store}>
        <Toaster position='top-right' toastOptions={toastrSettings} containerStyle={{ top: 30 }} />
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </ReduxProvider>
);

ReactDOM.render(app, document.getElementById('root'));
